import { Effect } from "../../Materials/effect";
var name = 'morphTargetsVertexGlobalDeclaration';
var shader = "#ifdef MORPHTARGETS\nuniform float morphTargetInfluences[NUM_MORPH_INFLUENCERS];\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var morphTargetsVertexGlobalDeclaration = { name: name, shader: shader };
//# sourceMappingURL=morphTargetsVertexGlobalDeclaration.js.map